import React, { useState } from 'react';
import { Modal, Button, Checkbox, Radio, Row, Col } from 'antd';
import instance from '../Communal/instance';
import { Alert } from '../Communal/utility';

function Export({
    open,//是否展示弹框
    onClose,//关闭弹框
    checkList,//选择的列表字段
    url,//接口路由
    title,//导出题目类型名称
}) {
    const [submit, setSubmit] = useState({
        method: 'all',//"all"(全部导出)、"by_review"(按审核状态导出)
        fields_list: [],//列表导出字段
        review_status: 1//审核状态 0: 待审核 1: 审核通过 2: 待补充 3: 拒绝
    })
    const downloadFile = (blobData, filename = '导出题目.xlsx', contentType = '') => {
        const blob = new Blob([blobData], {
            type: contentType || 'application/octet-stream'
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }, 100);
    };

    const handleOk = () => {
        let data = { ...submit }
        if (data.fields_list.length === 0) {
            delete data.fields_list;
        } else {
            data.fields_list.unshift('id')
        }
        if (data.method === 'all') {
            delete data.review_status;
        }
        instance.post(url, data, {
            responseType: 'blob'
        }).then(response => {
            downloadFile(response, `${title}.xlsx`)
            Alert('success', '导出成功');
            onClose()
        }).catch(err => {
            if (err.error) {
                Alert('error', err.error);
            }
        })
    }
    return (
        <Modal
            visible={open}
            centered={true}
            closable={false}
            title={'导出题目'}
            width={700}
            destroyOnClose
            footer={<div className="my-modal-footer">
                <Button className="cancel-btn" onClick={onClose}>取消</Button>
                <Button type="primary"
                    onClick={handleOk}>确认</Button>
            </div>}
        >
            <Row style={{ marginTop: '20px' }}>
                <Col span={4} style={{ textAlign: 'right', paddingRight: '10px' }}><b style={{ color: 'red' }}>*</b>导出方式</Col>
                <Col span={20}>
                    <Radio.Group
                        value={submit.method}
                        onChange={e => {
                            submit.method = e.target.value;
                            setSubmit({ ...submit })
                        }}
                    >
                        <Radio value={'all'}>导出全部状态</Radio>
                        <Radio value={'by_review'}>选择审核状态导出</Radio>
                    </Radio.Group>
                </Col>
            </Row>
            {
                submit?.method === 'by_review' &&
                <Row style={{ marginTop: '20px' }}>
                    <Col span={4} style={{ textAlign: 'right', paddingRight: '10px' }}>审核状态</Col>
                    <Col span={20}>
                        <Radio.Group
                            value={submit.review_status}
                            onChange={e => {
                                submit.review_status = e.target.value;
                                setSubmit({ ...submit })
                            }}
                        >
                            <Radio value={0}>待审核</Radio>
                            <Radio value={1}>审核通过</Radio>
                            <Radio value={2}>待补充</Radio>
                            <Radio value={3}>拒绝</Radio>
                        </Radio.Group>
                    </Col>
                </Row>
            }
            <Row style={{ marginTop: '20px' }}>
                <Col span={4} style={{ textAlign: 'right', paddingRight: '10px' }}>选择字段</Col>
                <Col span={20}>
                    <Checkbox.Group
                        options={checkList}
                        onChange={e => {
                            submit.fields_list = e;
                            setSubmit({ ...submit })
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={4}></Col>
                <Col span={20} style={{ color: 'orange' }}>
                    选择字段不选择时默认全部导出
                </Col>
            </Row>
        </Modal >
    )
}
export default Export;